import {
    GET_USERS,
    SET_PAGE,
    SET_ROWS,
    REMOVE_USER,
    SET_TABLE_CONFIG
} from "./types";
import firebase from "firebase/app";
import "firebase/auth";

export const getUsers = () => {
    return dispatch => {
        dispatch({ type: GET_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else dispatch({ type: GET_USERS.FAIL });
            });
        } catch {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};

export const setPage = (page = 0) => {
    return dispatch => {
        dispatch({ type: SET_PAGE, payload: page });
    };
};
export const setRow = (row = 50) => {
    return dispatch => {
        dispatch({ type: SET_ROWS, payload: row });
    };
};

export const removeUser = (uid, callback) => {
    return dispatch => {
        dispatch({ type: REMOVE_USER.REQUEST, payload: true });
        callback("removing");
        let cloudFunction = firebase.functions().httpsCallable("removeUser");
        try {
            cloudFunction(uid).then(e => {
                dispatch({ type: REMOVE_USER.SUCCESS, payload: false });
                callback(true);
            });
        } catch (e) {
            dispatch({ type: REMOVE_USER.FAIL });
            callback(false);
        }
    };
};
export const setTableConfig = (config = false) => {
    return dispatch => {
        dispatch({ type: SET_TABLE_CONFIG, payload: config });
    };
};
